// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 16px; */
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.card-wrapper {
  width: 100%;
  /* margin: 16px 0; */
}
.sec-card-wrapper {
  width: 100%;
  /* margin: 16px 0; */
}

.form-label {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.form-container {
  display: flex;
  flex-direction: column;
}

.form-wrapper {
  margin-bottom: 16px;
}

.link-wrapper {
  text-align: center;
}

.button-wrapper {
  text-align: center;
  margin-top: 16px;
}

.text-wrapper {
  text-align: center;
  padding: 16px;
}

.signin_child {
  display: flex;
  justify-content: flex-end;
}
.signin_child1 {
  display: flex;
  justify-content: space-between;
}

.signin__right__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 16px;
  width: 100%;
}

.signin__right__top__btn {
  display: flex;
  align-items: center;
}

.signin__right__top__btn img {
  margin-right: 8px;
}

.signin__right__top__rightcontent {
  white-space: nowrap;
  display: flex;
  padding: 2%;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}

.auth-layout-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.signin_left {
  display: "flex";
  justify-content: space-between;
}

.condition-dialog-wrapper .dialog-content {
  max-height: 400px;
  overflow-y: auto;
}

.dialog-action {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 480px) {
  .signin__right__top {
    width: 100%;
  }
  .signin_child1 {
    display: block;
  }
  .signin__leftimg {
    display: none;
  }
}

@media (min-width: 480px) and (max-width: 600px) {
  .signin__right__top {
    width: 100%;
  }
  .signin_child1 {
    display: block;
  }
  .signin__leftimg {
    display: none;
  }
}

@media (min-width: 600px) and (max-width: 800px) {
  .signin__right__top {
    width: 100%;
  }
  .signin_child1 {
    display: block;
  }
}
@media (min-width: 800px) and (max-width: 1200px) {
  .signin__leftimg {
    width: 40%;
  }
  .signin__right {
    width: 60%;
  }
}
@media (min-width: 1200px) and (max-width: 1500px) {
  .signin__right__top {
    width: 100%;
  }
  .signin__leftimg {
    width: 40%;
  }
  .signin__right {
    width: 60%;
  }
}
@media (min-width: 1500px) and (max-width: 3000px) {
  .signin__right__top {
    width: 100%;
  }
  .signin__leftimg {
    width: 40%;
  }
  .signin__right {
    width: 60%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".login-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding: 16px; */\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.card-wrapper {\n  width: 100%;\n  /* margin: 16px 0; */\n}\n.sec-card-wrapper {\n  width: 100%;\n  /* margin: 16px 0; */\n}\n\n.form-label {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-wrapper {\n  margin-bottom: 16px;\n}\n\n.link-wrapper {\n  text-align: center;\n}\n\n.button-wrapper {\n  text-align: center;\n  margin-top: 16px;\n}\n\n.text-wrapper {\n  text-align: center;\n  padding: 16px;\n}\n\n.signin_child {\n  display: flex;\n  justify-content: flex-end;\n}\n.signin_child1 {\n  display: flex;\n  justify-content: space-between;\n}\n\n.signin__right__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 16px 16px;\n  width: 100%;\n}\n\n.signin__right__top__btn {\n  display: flex;\n  align-items: center;\n}\n\n.signin__right__top__btn img {\n  margin-right: 8px;\n}\n\n.signin__right__top__rightcontent {\n  white-space: nowrap;\n  display: flex;\n  padding: 2%;\n  align-items: center;\n  width: 100%;\n  justify-content: flex-end;\n}\n\n.auth-layout-wrapper {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.signin_left {\n  display: \"flex\";\n  justify-content: space-between;\n}\n\n.condition-dialog-wrapper .dialog-content {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.dialog-action {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 480px) {\n  .signin__right__top {\n    width: 100%;\n  }\n  .signin_child1 {\n    display: block;\n  }\n  .signin__leftimg {\n    display: none;\n  }\n}\n\n@media (min-width: 480px) and (max-width: 600px) {\n  .signin__right__top {\n    width: 100%;\n  }\n  .signin_child1 {\n    display: block;\n  }\n  .signin__leftimg {\n    display: none;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 800px) {\n  .signin__right__top {\n    width: 100%;\n  }\n  .signin_child1 {\n    display: block;\n  }\n}\n@media (min-width: 800px) and (max-width: 1200px) {\n  .signin__leftimg {\n    width: 40%;\n  }\n  .signin__right {\n    width: 60%;\n  }\n}\n@media (min-width: 1200px) and (max-width: 1500px) {\n  .signin__right__top {\n    width: 100%;\n  }\n  .signin__leftimg {\n    width: 40%;\n  }\n  .signin__right {\n    width: 60%;\n  }\n}\n@media (min-width: 1500px) and (max-width: 3000px) {\n  .signin__right__top {\n    width: 100%;\n  }\n  .signin__leftimg {\n    width: 40%;\n  }\n  .signin__right {\n    width: 60%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
